import { render, staticRenderFns } from "./approveDetail.vue?vue&type=template&id=74815b57&scoped=true"
import script from "./approveDetail.vue?vue&type=script&lang=js"
export * from "./approveDetail.vue?vue&type=script&lang=js"
import style0 from "./approveDetail.vue?vue&type=style&index=0&id=74815b57&scoped=true&lang=css"
import style1 from "./approveDetail.vue?vue&type=style&index=1&id=74815b57&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74815b57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74815b57')) {
      api.createRecord('74815b57', component.options)
    } else {
      api.reload('74815b57', component.options)
    }
    module.hot.accept("./approveDetail.vue?vue&type=template&id=74815b57&scoped=true", function () {
      api.rerender('74815b57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/storeFeedback/approveReport/approveDetail.vue"
export default component.exports